<template>
  <div class="portal-case-card">
    <div class="header">
      <div>
        <span class="title">{{ type === 1 ? "热门资讯" : "技术文章" }}</span>
      </div>
      <a class="more" target="_blank" @click="handleMore">查看更多 ></a>
    </div>
    <div class="list">
      <ul>
        <li v-for="cases of caseList" :key="cases.id">
          <span></span>
          <a
            target="_blank"
            :href="cases.href"
            >{{ cases.title }}
            <em :class="cases.clazz" v-if="type === 1">{{
              cases.catalogName
            }}</em>
            <label v-if="type === 2 && cases.isHot">HOT</label>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { host } from "src/config";
import { qryCase } from "../../request/portal";

export default {
  name: "PortalCaseCard",
  props: {
    env: {
      type: String,
      default: "local",
    },
    /* 1、排除技术文章的 2、技术文章的 */
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      host: host(this.env),
      caseList: [{}],
    };
  },
  methods: {
    // 查询列表
    qryList() {
      const params = {
        pageRow: "5",
        pageNum: "1",
        qryNum: 5,
      };
      if (this.type === 2) params.alias = "jswz";
      if (this.type === 1) params.notAlias = "jswz";
      qryCase(params, this.host.nodeUrl).then((res) => {
        if (res && res.data && res.data.items) {
          res.data.items.forEach((v) => {
            v.clazz = "clazzA";
            if (v.catalogCode === "hzal") v.clazz = "clazzA";
            if (v.catalogCode === "zbyth") v.clazz = "clazzB";
            if (v.catalogCode === "bjdt") v.clazz = "clazzC";
            if (v.catalogCode === "jswz") v.clazz = "clazzD";
            if (v.catalogCode === "yhhd") v.clazz = "clazzE";
            if (v.catalogCode === "zhsh") v.clazz = "clazzF";
            if (window.location.host.includes("member")) {
              v.href = this.host.sgsonlineUrl + "/case/" + v.alias + "/detail-" + v.id + ".html";
            } else {
              v.href ="/case/" + v.alias + "/detail-" + v.id + ".html?catalogCode=" + v.catalogCode;
            }
          });
          this.caseList = res.data.items;
        }
      });
    },
    // 查看更多
    handleMore() {
      // 技术文章时，进入技术文章列表，其他进入全部
      let path = "/information";
      if (this.type === 2) {
        path += `?type=${this.caseList[0].catalogId}`;
      }
      // member域名站外，其他域名站内
      if (window.location.host.includes("member")) {
        window.open(this.host.sgsonlineUrl + path);
      } else {
        window.open(path);
      }
    },
  },
  mounted() {
    this.qryList();
  },
};
</script>

<style lang="scss">
@import "./../../assets/style/mixin.scss";

.portal-case-card {
  width: 400px;
  box-sizing: border-box;
  padding: 20px 25px;
  background: #fff;
  display: block;

  .header {
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 700;
      font-size: 16px;
      color: #333;
      padding-left: 13px;
      border-left: 3px solid $mainColor;
    }

    .refresh {
      margin-left: 28px;
      padding-left: 20px;
      color: $mainColor;
      font-size: 12px;
      background: url("./../../assets/images/portal/question/refresh.svg")
        no-repeat left center;
      cursor: pointer;
    }

    .more {
      color: $textColor;
      font-size: 12px;
    }
  }

  .list {
    margin-top: 15px;

    ul {
      padding: 0;
      margin: 0;
    }

    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 5px 0;

      span {
        width: 3px;
        height: 3px;
        background: #999;
        border-radius: 50%;
      }

      a {
        color: #333;
        font-size: 14px;
        padding-left: 12px;
        word-wrap: break-word;
        white-space: normal;
        word-break: break-all;
        flex: 1;
      }

      em {
        font-size: 12px;
        font-style: normal;
        padding: 3px 7px;
        border-radius: 2px;
        margin-left: 10px;
        display: inline-block;

        &.clazzA {
          color: #6b95c0;
          border: 1px solid #c8d9ec;
          background: #f0f8ff;
        }
        &.clazzB {
          color: #b1b1b1;
          border: 1px solid #dedede;
          background: #fafafa;
        }
        &.clazzC {
          color: #dc6e6e;
          border: 1px solid #fadddd;
          background: #fff5f5;
        }
        &.clazzD {
          color: #8e6fc0;
          border: 1px solid #e1ceff;
          background: #f6f1ff;
        }
        &.clazzE {
          color: #ff871e;
          border: 1px solid #ffddc6;
          background: #fff6f1;
        }
        &.clazzF {
          color: #8cca83;
          border: 1px solid #b9f9b0;
          background: #edffeb;
        }
      }

      label {
        background: $mainColor;
        color: #fff;
        font-size: 12px;
        border-radius: 3px;
        margin-left: 10px;
        display: inline-block;
      }
    }
  }

  a:hover {
    color: $mainColor !important;
  }
}
</style>
